<template>
  <v-dialog :model-value="modelValue" max-width="500" persistent @update:model-value="updateModelValue">
    <v-card>
      <v-card-title>{{ $t("ncrm.integrations.mailjet.dialog.delete.title") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <p class="mb-2">
          {{
            $t("ncrm.integrations.mailjet.dialog.delete.confirmText", {
              name: account?.name || "",
            })
          }}
        </p>
        <p class="text-medium-emphasis text-caption mb-2">
          {{ $t("ncrm.integrations.mailjet.dialog.delete.confirmHint") }}
        </p>
        <v-text-field
          v-model="confirmInput"
          :label="$t('ncrm.integrations.mailjet.dialog.delete.confirmType')"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="deleting" @click="close">
          {{ $t("ncrm.integrations.mailjet.dialog.actions.cancel") }}
        </v-btn>
        <v-btn
          color="error"
          :loading="deleting"
          :disabled="confirmInput !== 'DELETE'"
          @click="confirmDelete"
        >
          {{ $t("ncrm.integrations.mailjet.dialog.actions.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "NcrmMailjetDeleteDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    account: { type: Object, default: null },
  },
  emits: ["update:modelValue", "notify", "deleted"],
  data() {
    return {
      deleting: false,
      confirmInput: "",
    };
  },
  watch: {
    modelValue(value) {
      if (value) this.confirmInput = "";
    },
  },
  methods: {
    updateModelValue(value) {
      if (!this.deleting) this.$emit("update:modelValue", value);
    },
    close() {
      this.updateModelValue(false);
    },
    extractError(error, fallbackKey) {
      return (
        error?.response?.data?.error ||
        error?.message ||
        this.$t(fallbackKey)
      );
    },
    async confirmDelete() {
      if (this.confirmInput !== "DELETE" || !this.account?.id) return;
      this.deleting = true;
      try {
        await axios.delete(`/ncrm/integrations/mailjet/accounts/${this.account.id}`);
        this.$emit("notify", {
          message: this.$t("ncrm.integrations.mailjet.snackbar.deleted"),
          color: "success",
        });
        this.$emit("update:modelValue", false);
        this.$emit("deleted");
      } catch (error) {
        this.$emit("notify", {
          message: this.extractError(error, "ncrm.integrations.mailjet.snackbar.deleteError"),
          color: "error",
        });
      } finally {
        this.deleting = false;
      }
    },
  },
};
</script>
